module.exports = __webpack_public_path__ + "img/offers2.8e3cc5c1.webp";